/**
 * BLOCK: FAQ - Schema - Child
 */

import WPSPBlockIcons from '@Controls/block-icons';
import attributes from './attributes';
import edit from './edit';
import save from './save';
import './style.scss';
import { registerBlockType } from '@wordpress/blocks';

registerBlockType('wpsp/faq-child', {
	title: wpsp_blocks_info.blocks['wpsp/faq-child'].title,
	description: wpsp_blocks_info.blocks['wpsp/faq-child'].description,
	icon: WPSPBlockIcons.faq,
	category: wpsp_blocks_info.category,
	parent: ['wpsp/faq'],
	attributes,
	edit,
	supports: {
		anchor: true,
	},
	save,
});
